// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"kN-z","inlineTitle":"lN-z","sponsoredAdsWrapper":"mN-z","marketplaceRecosWrapper":"nN-z"};